<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn
        class="select-documents"
        :class="[setClass]"
        v-on="on"
        depressed
        outlined
        height="32px"
      >
        {{ $t('common.common_document') }}
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, i) in itemLists"
        :key="i"
        @click="submit(item)"
      >
        <v-list-item-content>
          <v-list-item-title>
            {{ $t(item.title) }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    isRowInfo: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  computed: {
    itemLists() {
      // 発注書
      const purchaseOrder = {
        title: 'order.order_purchase-order',
        type: 'purchaseOrder'
      }
      // 販売履歴一覧（CSV）
      const orderHistoryCsv = {
        title: 'order.order_order-history-list-csv',
        type: 'orderHistoryCsv'
      }

      return [purchaseOrder, orderHistoryCsv]
    },
    setClass() {
      const color = this.color == 'white' ? '' : this.color
      return 'font-weight-bold ' + 'white' + ' ' + 'thinText--text'
    }
  },
  methods: {
    submit(item) {
      this.$emit('submit', item.type)
    }
  }
}
</script>

<style lang="scss" scoped>
.select-documents {
  width: 60px;
  height: 32px !important;
  font-size: 12px;
  border: thin solid #c8cfd7 !important;
}
</style>
